import { sendRequest } from './index';
import { API_CV_URL } from '@core/constants/API';

export const myResumeService = ({ query }) => {
	return sendRequest({
		url: `${API_CV_URL}my-resume?${query ? query : ''}`,
		method: 'GET'
	});
};

export const exportResume = () => {
	return sendRequest({
		url: `${API_CV_URL}resume-pdf`,
		method: 'GET',
		responseType: 'arraybuffer',
	});
};

export const exportMyResumeWithNewTemplates = {
	POST: (templateName) =>
		sendRequest({
			url: `${API_CV_URL}cv-templates/${templateName}/download`,
			method: 'POST',
			body: {}
		}),
};

export const certificateService = {
	PUT: (payload) =>
		sendRequest({
			url: `${API_CV_URL}certificate-metadata`,
			method: 'PUT',
			body: payload
		}),
};

export const workExperienceServices = {
	GET: () =>
		sendRequest({
			url: `${API_CV_URL}work-experiences`,
			method: 'GET'
		}),
	POST: (payload) =>
		sendRequest({
			url: `${API_CV_URL}work-experiences`,
			method: 'POST',
			body: payload
		}),
	PUT: (payload) =>
		sendRequest({
			url: `${API_CV_URL}work-experiences/${payload.id}`,
			method: 'PUT',
			body: payload
		}),
	DELETE: (id) =>
		sendRequest({
			url: `${API_CV_URL}work-experiences/${id}`,
			method: 'DELETE'
		})
};

export const educationServices = {
	GET: () =>
		sendRequest({
			url: `${API_CV_URL}education`,
			method: 'GET'
		}),
	POST: (payload) =>
		sendRequest({
			url: `${API_CV_URL}education`,
			method: 'POST',
			body: payload
		}),
	PUT: (payload) =>
		sendRequest({
			url: `${API_CV_URL}education/${payload.id}`,
			method: 'PUT',
			body: payload
		}),
	DELETE: (id) =>
		sendRequest({
			url: `${API_CV_URL}education/${id}`,
			method: 'DELETE'
		})
};

export const skillsServices = {
	GET: () =>
		sendRequest({
			url: `${API_CV_URL}skills`,
			method: 'GET'
		}),
	PUT: (payload) =>
		sendRequest({
			url: `${API_CV_URL}skills`,
			method: 'PUT',
			body: payload
		}),
};

export const carrerGoalServices = {
	PUT: (payload) =>
		sendRequest({
			url: `${API_CV_URL}career-goals`,
			method: 'PUT',
			body: payload
		}),
	GET: () =>
		sendRequest({
			url: `${API_CV_URL}career-goals`,
			method: 'GET'
		})
};

export const cvAboutMeServices = {
	PUT: (payload) =>
		sendRequest({
			url: `${API_CV_URL}about-me`,
			method: 'PUT',
			body: payload
		}),
	GET: () =>
		sendRequest({
			url: `${API_CV_URL}about-me`,
			method: 'GET'
		})
};

export const contactInformayionServices = {
	PUT: (payload) =>
		sendRequest({
			url: `${API_CV_URL}contact-information`,
			method: 'PUT',
			body: payload
		}),
	GET: () =>
		sendRequest({
			url: `${API_CV_URL}contact-information`,
			method: 'GET'
		})
};

export const publicUrlsServices = {
	PUT: (payload) =>
		sendRequest({
			url: `${API_CV_URL}public-urls`,
			method: 'PUT',
			body: payload
		}),
	GET: () =>
		sendRequest({
			url: `${API_CV_URL}public-urls`,
			method: 'GET'
		})
};

export const getPublicProfile = (payload) => {
	return sendRequest({
		url: `${API_CV_URL}public-profile/${payload}`,
		method: 'GET'
	});
}

export const getPublicProfileCertificates = (payload) => {
	return sendRequest({
		url: `${API_CV_URL}public-profile/${payload.url}/certificates${payload.searchParams}`,
		method: 'GET'
	});
}

export const ContentCertificatePdfPublicProfileService = (payload) => {
	return sendRequest({
		url: `${API_CV_URL}public-profile/${payload.url}/certificates/${payload.id}/links`,
		method: 'GET'
	});
};

export const certificateMetaDataServices = {
	PUT: (payload) =>
		sendRequest({
			url: `${API_CV_URL}certificate-metadata`,
			method: 'PUT',
			body: payload
		}),
	GET: () =>
		sendRequest({
			url: `${API_CV_URL}certificate-metadata`,
			method: 'GET',
		}),
};

export const publicMetaDataServices = {
	PUT: (payload) =>
		sendRequest({
			url: `${API_CV_URL}public-urls/metadata`,
			method: 'PUT',
			body: payload
		}),
	GET: () =>
		sendRequest({
			url: `${API_CV_URL}public-urls/metadata`,
			method: 'GET',
		}),
};


export const resumeSmartImportService = {
	POST: (payload) =>
		sendRequest({
			url: `${API_CV_URL}smart-import`,
			method: 'POST',
			body: payload
		}),
};

export const smartImportCheckService = () => {
	return sendRequest({
		url: `${API_CV_URL}smart-import/status`,
		method: 'GET'
	});
};

export const resumeSkillCategoriesEstimate = {
	POST: () =>
		sendRequest({
			url: `${API_CV_URL}skill-insights`,
			method: 'POST',
		}),
	GET: () =>
		sendRequest({
			url: `${API_CV_URL}skill-insights/status`,
			method: 'GET',
		}),	
};

export const getSkillInsights = () => {
	return sendRequest({
		url: `${API_CV_URL}skill-insights`,
		method: 'GET'
	});
};